export default __webpack_public_path__ + "static/media/Logo.44bedb99.svg";